import {SpecialCategories} from './uploads';
import {dataFileUploadModuleFactory} from '../utils';

export default dataFileUploadModuleFactory(SpecialCategories.EMPLOYEES, {
   actions: {
      async uploadFile({state, dispatch}, {companyId, periodId}) {
         const response = await dispatch('_uploadFile');
         await dispatch(
            'legacyEmployees/loadEmployees',
            {companyId, periodId: periodId ?? state.pendingUpload.periodId},
            {root: true}
         );
         return response;
      },
   },
});
